/* SMC Wishlist — self-hosted replacement for Swym Wishlist Plus.
   Config injected by snippets/smc-wishlist.liquid as window.SMCWL:
   { api, shop, cid, email, product: {id, handle, title, image, priceCents} | null } */
(function () {
  'use strict';
  var CFG = window.SMCWL;
  if (!CFG || !CFG.api) return;

  var HEART =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"><path d="M19.6706 5.4736C17.6806 3.8336 14.7206 4.1236 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.05064 7.3536 1.93063 10.7436 3.97063 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 21.9506 7.3636 19.6706 5.4736Z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  // ---------- identity ----------
  function sid() {
    var s = localStorage.getItem('smcwl:sid');
    if (!s) {
      s = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2));
      localStorage.setItem('smcwl:sid', s);
    }
    return s;
  }

  var state = { lists: [], count: 0 };
  var inWishlist = {}; // productId -> itemId (any list)

  function indexState() {
    inWishlist = {};
    state.lists.forEach(function (l) {
      l.items.forEach(function (it) {
        inWishlist[String(it.product_id)] = it.id;
      });
    });
  }

  function cacheLoad() {
    try {
      var c = JSON.parse(localStorage.getItem('smcwl:state') || 'null');
      if (c && c.lists) { state = c; indexState(); }
    } catch (e) { /* ignore */ }
  }

  function setState(s) {
    state = s;
    indexState();
    try { localStorage.setItem('smcwl:state', JSON.stringify(s)); } catch (e) { /* ignore */ }
    paintAll();
  }

  // ---------- api ----------
  function api(path, body) {
    var ident = { shop: CFG.shop, sid: sid() };
    if (CFG.cid) ident.cid = String(CFG.cid);
    if (CFG.email) ident.email = CFG.email;
    if (body) {
      return fetch(CFG.api + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign(ident, body))
      }).then(function (r) { return r.json(); });
    }
    var q = new URLSearchParams(ident).toString();
    return fetch(CFG.api + path + '?' + q).then(function (r) { return r.json(); });
  }

  function refresh() {
    return api('/api/wishlist').then(function (s) {
      if (s && s.lists) setState(s);
    }).catch(function () { /* offline: keep cache */ });
  }

  function mergeIfNeeded() {
    if (!CFG.cid) return Promise.resolve();
    var flag = 'smcwl:merged:' + CFG.cid;
    if (localStorage.getItem(flag)) return Promise.resolve();
    return api('/api/merge', {}).then(function (s) {
      localStorage.setItem(flag, '1');
      if (s && s.lists) setState(s);
    }).catch(function () { /* retry next page view */ });
  }

  // ---------- ui: hearts ----------
  function paintButton(btn) {
    var pid = btn.getAttribute('data-smcwl-pid');
    var on = !!inWishlist[pid];
    btn.classList.toggle('smcwl-on', on);
    btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    if (btn.hasAttribute('data-smcwl-text')) {
      btn.querySelector('.smcwl-btn-label').textContent = on ? 'Added to wishlist' : 'Add to wishlist';
    }
  }

  function paintAll() {
    document.querySelectorAll('[data-smcwl-pid]').forEach(paintButton);
    paintHeaderCount();
  }

  function cardMeta(card) {
    var link = card.querySelector('a[href*="/products/"]');
    var img = card.querySelector('img');
    var title = card.querySelector('.product-block__title');
    var handle = '';
    if (link) {
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m) handle = m[1];
    }
    return {
      productId: card.getAttribute('data-product-id'),
      handle: handle,
      title: title ? title.textContent.trim() : (img ? img.alt : ''),
      image: img ? (img.currentSrc || img.src) : ''
    };
  }

  function toggle(product, btn) {
    var pid = String(product.productId);
    var was = !!inWishlist[pid];
    // optimistic paint
    if (btn) { btn.classList.toggle('smcwl-on', !was); }
    var p = was
      ? api('/api/wishlist/remove', { productId: pid })
      : api('/api/wishlist/add', { product: product });
    p.then(function (s) {
      if (s && s.lists) setState(s);
      if (!was) {
        toast('Added to wishlist', pid);
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'AddToWishlist', { content_ids: [pid], content_type: 'product', content_name: product.title });
        }
      }
    }).catch(function () { if (btn) paintButton(btn); });
  }

  function injectCardHearts(root) {
    (root || document).querySelectorAll('product-block[data-product-id], .product-block[data-product-id]').forEach(function (card) {
      if (card.querySelector('.smcwl-heart')) return;
      var imageWrap = card.querySelector('.block-inner-inner') || card;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'smcwl-heart';
      btn.setAttribute('data-smcwl-pid', card.getAttribute('data-product-id'));
      btn.innerHTML = HEART;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle(cardMeta(card), btn);
      });
      imageWrap.style.position = imageWrap.style.position || 'relative';
      imageWrap.appendChild(btn);
      paintButton(btn);
    });
  }

  function injectPdpButton() {
    if (!CFG.product || !CFG.product.id) return;
    if (document.querySelector('[data-smcwl-pdp]')) return;
    var anchor = document.querySelector('.product-info__buy-buttons, .buy-buttons, form[action*="/cart/add"]');
    if (!anchor) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'smcwl-pdp-btn';
    btn.setAttribute('data-smcwl-pdp', '1');
    btn.setAttribute('data-smcwl-pid', String(CFG.product.id));
    btn.setAttribute('data-smcwl-text', '1');
    btn.innerHTML = HEART + '<span class="smcwl-btn-label">Add to wishlist</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggle({
        productId: String(CFG.product.id),
        handle: CFG.product.handle,
        title: CFG.product.title,
        image: CFG.product.image,
        priceCents: CFG.product.priceCents
      }, btn);
    });
    anchor.parentNode.insertBefore(btn, anchor.nextSibling);
    paintButton(btn);
  }

  // ---------- ui: header icon ----------
  function injectHeader() {
    document.querySelectorAll('a.cart-link, a[href="/cart"]').forEach(function (cart) {
      if (cart.parentNode.querySelector('.smcwl-header-icon')) return;
      var a = document.createElement('a');
      a.href = '/pages/wishlist';
      a.className = 'smcwl-header-icon';
      a.setAttribute('aria-label', 'Wishlist');
      a.innerHTML = HEART + '<span class="smcwl-header-count" hidden>0</span>';
      cart.parentNode.insertBefore(a, cart);
    });
    paintHeaderCount();
  }

  function paintHeaderCount() {
    var v = String(state.count || 0);
    var hide = !state.count;
    document.querySelectorAll('.smcwl-header-count').forEach(function (el) {
      // guarded writes: identical textContent still replaces the text node and
      // would re-trigger the MutationObserver forever
      if (el.textContent !== v) el.textContent = v;
      if (el.hidden !== hide) el.hidden = hide;
    });
  }

  // ---------- ui: toast ----------
  var toastTimer;
  function toast(msg, pid) {
    var t = document.querySelector('.smcwl-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'smcwl-toast';
      document.body.appendChild(t);
    }
    t.innerHTML = '<span>' + msg + '</span> <a href="/pages/wishlist">View</a>' +
      (state.lists.length > 1 && pid ? ' <button type="button" class="smcwl-move">Change list</button>' : '');
    var mv = t.querySelector('.smcwl-move');
    if (mv) mv.addEventListener('click', function () { openListPicker(pid); t.classList.remove('smcwl-toast--show'); });
    t.classList.add('smcwl-toast--show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('smcwl-toast--show'); }, 3500);
  }

  // ---------- ui: list picker ----------
  function openListPicker(pid) {
    closeListPicker();
    var item = null;
    state.lists.forEach(function (l) {
      l.items.forEach(function (it) { if (String(it.product_id) === String(pid)) item = it; });
    });
    var pop = document.createElement('div');
    pop.className = 'smcwl-popup';
    var inner = '<div class="smcwl-popup__box"><h3>Choose or Create new wishlist</h3><div class="smcwl-popup__lists">';
    state.lists.forEach(function (l) {
      inner += '<button type="button" data-list="' + l.id + '">' + escapeHtml(l.name) + ' (' + l.items.length + ')</button>';
    });
    inner += '</div><div class="smcwl-popup__new"><input type="text" placeholder="Enter wish list name" maxlength="80">' +
      '<button type="button" class="smcwl-popup__create">Create</button></div>' +
      '<button type="button" class="smcwl-popup__close" aria-label="Close">&times;</button></div>';
    pop.innerHTML = inner;
    document.body.appendChild(pop);

    function moveTo(listId) {
      var meta = item ? {
        productId: String(item.product_id), handle: item.handle, title: item.title,
        image: item.image, priceCents: item.price_cents
      } : null;
      if (!meta) { closeListPicker(); return; }
      api('/api/wishlist/remove', { productId: meta.productId }).then(function () {
        return api('/api/wishlist/add', { listId: listId, product: meta });
      }).then(function (s) { if (s && s.lists) setState(s); closeListPicker(); });
    }
    pop.querySelectorAll('[data-list]').forEach(function (b) {
      b.addEventListener('click', function () { moveTo(parseInt(b.getAttribute('data-list'), 10)); });
    });
    pop.querySelector('.smcwl-popup__create').addEventListener('click', function () {
      var name = pop.querySelector('input').value.trim();
      if (!name) return;
      api('/api/list/create', { name: name }).then(function (s) {
        if (s && s.lists) {
          setState(s);
          var created = s.lists.filter(function (l) { return l.name === name; }).pop();
          if (created) moveTo(created.id); else closeListPicker();
        }
      });
    });
    pop.querySelector('.smcwl-popup__close').addEventListener('click', closeListPicker);
    pop.addEventListener('click', function (e) { if (e.target === pop) closeListPicker(); });
  }

  function closeListPicker() {
    var p = document.querySelector('.smcwl-popup');
    if (p) p.remove();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---------- wishlist page ----------
  function renderPage() {
    var mount = document.getElementById('smc-wishlist-page');
    if (!mount) return;
    var sharedToken = new URLSearchParams(location.search).get('shared');
    if (sharedToken) {
      fetch(CFG.api + '/api/shared?' + new URLSearchParams({ shop: CFG.shop, token: sharedToken }))
        .then(function (r) { return r.json(); })
        .then(function (l) {
          if (!l || !l.items) { mount.innerHTML = '<p>This shared wishlist was not found.</p>'; return; }
          mount.innerHTML = '<h2 class="smcwl-page-title">' + escapeHtml(l.name) + ' (shared)</h2>' + gridHtml(l.items, false);
        });
      return;
    }
    function draw() {
      if (!state.lists.length || !state.count) {
        mount.innerHTML = '<div class="smcwl-empty"><p>Your wishlist is empty.</p><a class="btn" href="/collections/all">Continue shopping</a></div>';
        if (!state.lists.length) return;
      }
      var html = '';
      if (state.count) {
        html += '<div class="smcwl-tabs">';
        state.lists.forEach(function (l, i) {
          html += '<button type="button" class="smcwl-tab' + (i === activeTab ? ' smcwl-tab--on' : '') + '" data-i="' + i + '">' +
            escapeHtml(l.name) + ' (' + l.items.length + ')</button>';
        });
        html += '<button type="button" class="smcwl-tab smcwl-tab--new" data-new="1">+ New list</button></div>';
        var l = state.lists[activeTab] || state.lists[0];
        html += '<div class="smcwl-actions"><button type="button" class="smcwl-share" data-list="' + l.id + '">Share this list</button>' +
          (state.lists.length > 1 ? '<button type="button" class="smcwl-dellist" data-list="' + l.id + '">Delete list</button>' : '') + '</div>';
        html += gridHtml(l.items, true);
        mount.innerHTML = html;
        mount.querySelectorAll('.smcwl-tab[data-i]').forEach(function (b) {
          b.addEventListener('click', function () { activeTab = parseInt(b.getAttribute('data-i'), 10); draw(); });
        });
        var nb = mount.querySelector('[data-new]');
        if (nb) nb.addEventListener('click', function () {
          var name = prompt('Name your wishlist:');
          if (name && name.trim()) api('/api/list/create', { name: name.trim() }).then(function (s) { if (s.lists) { setState(s); activeTab = s.lists.length - 1; draw(); } });
        });
        mount.querySelectorAll('.smcwl-remove').forEach(function (b) {
          b.addEventListener('click', function () {
            api('/api/wishlist/remove', { itemId: parseInt(b.getAttribute('data-item'), 10) })
              .then(function (s) { if (s.lists) { setState(s); draw(); } });
          });
        });
        var sh = mount.querySelector('.smcwl-share');
        if (sh) sh.addEventListener('click', function () {
          api('/api/share', { listId: parseInt(sh.getAttribute('data-list'), 10) }).then(function (r) {
            if (!r.token) return;
            var url = location.origin + '/pages/wishlist?shared=' + r.token;
            if (navigator.share) { navigator.share({ title: 'My wishlist', url: url }); }
            else { navigator.clipboard.writeText(url); sh.textContent = 'Link copied!'; setTimeout(function () { sh.textContent = 'Share this list'; }, 2000); }
          });
        });
        var dl = mount.querySelector('.smcwl-dellist');
        if (dl) dl.addEventListener('click', function () {
          if (!confirm('Delete this list and all items in it?')) return;
          api('/api/list/delete', { listId: parseInt(dl.getAttribute('data-list'), 10) })
            .then(function (s) { if (s.lists) { setState(s); activeTab = 0; draw(); } });
        });
      }
    }
    var activeTab = 0;
    draw();
    refresh().then(draw);
  }

  function gridHtml(items, removable) {
    if (!items.length) return '<p class="smcwl-none">No items in this list yet.</p>';
    var h = '<div class="smcwl-grid">';
    items.forEach(function (it) {
      h += '<div class="smcwl-card">' +
        '<a href="/products/' + encodeURIComponent(it.handle) + '">' +
        (it.image ? '<img loading="lazy" src="' + escapeHtml(it.image) + '" alt="">' : '<div class="smcwl-noimg"></div>') +
        '<div class="smcwl-card-title">' + escapeHtml(it.title || it.handle) + '</div></a>' +
        (it.available === 0 ? '<div class="smcwl-oos">Sold out</div>' : '') +
        (removable ? '<button type="button" class="smcwl-remove" data-item="' + it.id + '" aria-label="Remove">&times;</button>' : '') +
        '</div>';
    });
    return h + '</div>';
  }

  // ---------- boot ----------
  function boot() {
    cacheLoad();
    injectHeader();
    injectCardHearts();
    injectPdpButton();
    renderPage();
    paintAll();
    mergeIfNeeded().then(refresh);
    var scanQueued = false;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) {
          if (!scanQueued) {
            scanQueued = true;
            requestAnimationFrame(function () {
              scanQueued = false;
              injectCardHearts();
              injectHeader();
            });
          }
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
